import type { IResponse } from '@/features/api/extranet';
import type { LovDTO } from '@/features/api/extranet/dto/Lov'
import { ensureSuccessStatusCode, useFetch } from '@/features/fetch'

export type ExtraLov = { Idcc: LovDTO<string>; Naf: LovDTO<string>; IdccKeys: Set<string>; NafKeys: Set<string> }
let allLov: ExtraLov | null = null

async function loadLov(path: string) {
  const fetch = useFetch('extranet')
  const response = await fetch(path, { sablier: true, dialogMode: 'retry' })
  ensureSuccessStatusCode(response)

  const lov = (await response.json()) as IResponse<LovDTO<string>>

  return lov.data.reduce(
    (result, item) => {
      result.lov.push(item)
      result.keys.add(item.code)
      return result
    },
    {
      lov: [] as LovDTO<string>,
      keys: new Set<string>(),
    },
  )
}

async function loadAllLov() {
  const lovIdcc = await loadLov('/lov/idcc?estChampAkto=true&page=0&pagesize=1000')
  const lovNaf = await loadLov('/lov/naf')

  const lov: typeof allLov = {
    Idcc: lovIdcc.lov,
    Naf: lovNaf.lov,
    IdccKeys: lovIdcc.keys,
    NafKeys: lovNaf.keys,
  }
  allLov = Object.freeze(lov)
}

export async function loadExtaLov(): Promise<ExtraLov> {
  if (!allLov) await loadAllLov()
  return allLov!
}

